import React from 'react';
import './ConfirmationDialog.css';

interface ConfirmationDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonClass?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonClass = 'confirm-button',
  onConfirm,
  onCancel,
  loading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirmation-overlay" onClick={onCancel}>
      <div className="confirmation-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirmation-header">
          <h3>{title}</h3>
        </div>
        
        <div className="confirmation-body">
          <div 
            style={{ 
              whiteSpace: 'pre-line',
              lineHeight: '1.6'
            }}
          >
            {message}
          </div>
        </div>
        
        <div className="confirmation-actions">
          <button 
            onClick={onConfirm} 
            className={`${confirmButtonClass} ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? 'Processing...' : confirmText}
          </button>
          <button 
            onClick={onCancel} 
            className="cancel-button"
            disabled={loading}
          >
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
};